import React from "react";
import { Button } from "@mui/material";
import * as PortOne from "@portone/browser-sdk/v2";
import { useConfirm } from '@components/ConfirmProvider'
import { useIsMobile } from '@/hooks/Responsive'

const PhoneIdentityVerification = ({ onSuccess, disabled, fullWidth, mode }) => {
  const { alert, confirm } = useConfirm();
  const { isMobile } = useIsMobile()

  const handleVerify = async () => {
    const storeId = process.env.REACT_APP_PORTONE_STORE_ID;
    const channelKey = process.env.REACT_APP_PORTONE_CHANNEL_KEY;

    if (!storeId || !channelKey) {
      alert("PortOne Store ID 또는 Channel Key가 설정되지 않았습니다.");
      return;
    }

    // 각 본인인증 건을 구분하는 ID
    const identityVerificationId = "iv-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);

    const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    const redirectUrl = isMobile
      ? `${window.location.origin}/portone/identity-callback?mode=${mode || "default"}`
      : undefined;

    try {
      const response = await PortOne.requestIdentityVerification({
        storeId: storeId,
        channelKey: channelKey,
        identityVerificationId: identityVerificationId,
        redirectUrl,
      });

      // 모바일은 콜백 페이지에서 처리하므로 그냥 return
      if (redirectUrl) {
        return;
      }

      // 에러 코드가 존재하면 실패
      if (response.code !== undefined) {
        alert(response.message);
        return;
      }

      // API 검증
      const result = await fetch(process.env.REACT_APP_API_BASE + "/knouComm/api/identity-verifications", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ identityVerificationId }),
      });

      if (!result.ok) {
        const errorText = await result.text();
        throw new Error("서버 검증 실패: " + errorText);
      }

      const verified = await result.json();
      onSuccess?.(verified);

      // alert(verified.name + "님 본인인증이 완료되었습니다!");

    } catch (e) {
      //console.error(e);
      // alert("본인인증 중 오류가 발생했습니다.");
    }
  };

  return (
    <Button variant="contained" size="large" color="primary" onClick={handleVerify} disabled={disabled} fullWidth={fullWidth} sx={{ width: isMobile ? '100%' : 'auto' }}>
      본인인증
    </Button>
  );
};

export default PhoneIdentityVerification;
